"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.json = void 0;
var parser_1 = require("@masala/parser");
var take_1 = require("./take");
var try_all_1 = require("./try-all");
function json() {
    var NULL = parser_1.C.string('null');
    var OPEN = parser_1.C.char('{');
    var CLOSE = parser_1.C.char('}');
    var DOTS = parser_1.C.char(':');
    var COMMA = parser_1.C.char(',');
    var NUMBER = parser_1.N.number();
    var STRING = parser_1.C.stringLiteral();
    function objectOrNothing() {
        // FIXME: ES2015 code not great
        var value = {};
        var addValue = function (entry) {
            value[entry[0]] = entry[1];
            return value;
        };
        var getValue = function () { return value; };
        var attribute = take_1.take([STRING, DOTS.drop(), parser_1.F.lazy(expr)])
            .array()
            .map(addValue);
        return take_1.take([attribute, take_1.take([COMMA.drop(), attribute]).optrep()])
            .array()
            .opt()
            .map(getValue);
    }
    function expr() {
        var OBJECT = OPEN.drop()
            .then(parser_1.F.lazy(objectOrNothing))
            .then(CLOSE.drop())
            .single();
        return try_all_1.tryAll([NUMBER, STRING, NULL.returns(null), OBJECT]);
    }
    return expr();
}
exports.json = json;
//# sourceMappingURL=json.js.map